"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = amplitudeSubscriber;
var _utils = require("../utils");
var _excluded = ["amplitudeEvent", "amplitudeUserProperties", "actionType", "actionFlow"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ONETRUST_FUNCTIONAL_COOKIE_GROUP = 'C0003';
var blockedByOneTrust = function blockedByOneTrust() {
  var overrideOneTrust = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var _parseOneTrustCookie = (0, _utils.parseOneTrustCookie)(),
    hasOneTrustCookie = _parseOneTrustCookie.hasOneTrustCookie,
    oneTrustGroups = _parseOneTrustCookie.groups;

  // we are blocked by OneTrust if...
  return (
    // we're not overridden to _ignore_ OneTrust...
    !overrideOneTrust &&
    // the OneTrust cookie is not present or does not have
    // functional cookies accepted
    !(hasOneTrustCookie && oneTrustGroups[ONETRUST_FUNCTIONAL_COOKIE_GROUP] === true)
  );
};
var conditionallyAddKey = function conditionallyAddKey(keyName, value, out) {
  if (value) {
    // the whole point of this method is to populate a single object with props,
    // so passing that object around by reference is the most performant
    // eslint-disable-next-line no-param-reassign
    out[keyName] = value;
  }
};
var hydrateDefaultUserProps = function hydrateDefaultUserProps(user) {
  var _user$group, _user$group$membershi;
  var userProps = {};
  conditionallyAddKey('languageId', user === null || user === void 0 ? void 0 : user.languageId, userProps);
  conditionallyAddKey('userPackageId', user === null || user === void 0 ? void 0 : user.package, userProps);
  conditionallyAddKey('userPackageName', user === null || user === void 0 ? void 0 : user.packageName, userProps);
  conditionallyAddKey('userSubscriptionStatus', user === null || user === void 0 ? void 0 : user.subscriptionStatus, userProps);
  conditionallyAddKey('dateJoined', user === null || user === void 0 ? void 0 : user.joinedAt, userProps);
  conditionallyAddKey('dateSubscribed', user === null || user === void 0 ? void 0 : user.subscribedAt, userProps);
  conditionallyAddKey('userRole', (_user$group = user.group) === null || _user$group === void 0 ? void 0 : (_user$group$membershi = _user$group.membership) === null || _user$group$membershi === void 0 ? void 0 : _user$group$membershi.type, userProps);
  return userProps;
};
function amplitudeSubscriber(digitalDataEvent, config) {
  var _user$session, _amplitudeRequire$def;
  var amplitudeToken = config.amplitudeToken,
    user = config.user,
    overrideOneTrust = config.overrideOneTrust;
  var digitalData = digitalDataEvent.data;
  var amplitudeEvent = digitalData.amplitudeEvent,
    amplitudeUserProperties = digitalData.amplitudeUserProperties,
    actionType = digitalData.actionType,
    actionFlow = digitalData.actionFlow,
    data = _objectWithoutProperties(digitalData, _excluded);
  if (
  // bail if we have no ampltude token...
  !amplitudeToken ||
  // ...or if this is not an amplitude event...
  !amplitudeEvent || // ...or if the user is being impersonated by an admin...
  user !== null && user !== void 0 && (_user$session = user.session) !== null && _user$session !== void 0 && _user$session.isAdminImpersonation ||
  // ...or if OneTrust functional cookies haven't been accepted
  blockedByOneTrust(overrideOneTrust)) {
    return;
  }
  var userId = user.id,
    isAuthenticated = user.isAuthenticated,
    group = user.group,
    email = user.email;

  // we'll include the amplitude SDK here via "require" to avoid getting
  // yelled at by the test runner since amplitude makes explicit references
  // to "window", which doesn't exist in the test environment before we mock it
  // eslint-disable-next-line global-require
  var amplitudeRequire = require('amplitude-js');

  // this is to catch a bundling issue that was introduced with amplitude-js@8.11.0
  // that used the ESM module instead of the default `main` import:
  // https://github.com/amplitude/Amplitude-JavaScript/commit/3e98d506f003ba428ab08796d1246ccb387d1f32
  var amplitude = (_amplitudeRequire$def = amplitudeRequire.default) !== null && _amplitudeRequire$def !== void 0 ? _amplitudeRequire$def : amplitudeRequire;
  try {
    var amplitudeInstance = amplitude.getInstance();
    amplitudeInstance.init(amplitudeToken, null, {
      includeReferrer: true,
      includeFbclid: true,
      includeGclid: true,
      includeUtm: true,
      trackingOptions: {
        ip_address: false
      }
    });
    amplitudeInstance.setTransport('beacon');
    if (isAuthenticated) {
      var _group$membership;
      // if the user belongs to a team, send that down as a group property
      // set this before the user props below so that group info is sent as part
      // of the user props call
      if (group !== null && group !== void 0 && (_group$membership = group.membership) !== null && _group$membership !== void 0 && _group$membership.groupId) {
        var _group$membership2;
        amplitudeInstance.setGroup('teamId', group === null || group === void 0 ? void 0 : (_group$membership2 = group.membership) === null || _group$membership2 === void 0 ? void 0 : _group$membership2.groupId);
      }
      amplitudeInstance.setUserId(userId);

      // add in any core props if they're present on the user object
      var userProps = hydrateDefaultUserProps(user);

      // mix in any supplied user props
      if (Object.prototype.toString.call(amplitudeUserProperties) === '[object Object]') {
        userProps = _objectSpread(_objectSpread({}, userProps), amplitudeUserProperties);
      }
      if (email) {
        var _email$split = email.split('@'),
          _email$split2 = _slicedToArray(_email$split, 2),
          emailDomain = _email$split2[1];

        // make extremely sure that we've got a real email and will only be sending the domain
        if (emailDomain && emailDomain.indexOf('.') > -1) {
          userProps.emailDomain = emailDomain;
        }
      }
      amplitudeInstance.setUserProperties(userProps);
    } else {
      // make sure we've cleared out the data for any previous logged in user
      amplitudeInstance.clearStorage();
    }
    amplitudeInstance.logEvent(amplitudeEvent, _objectSpread({}, data));
  } catch (err) {
    // silently fail; we don't want a bad metrics call taking the whole experience down
  }
}
module.exports = exports.default;
//# sourceMappingURL=AmplitudeSubscriber.js.map